import React from 'react';
import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';

import {
  Button,
  ButtonsWrapper,
  DatePickerInput,
  Form,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';

import { EmployeeContractTypesEnum } from '@thinknet-gmbh/platform-common';

import { IWorkingConditionContract } from '../../../employee.interfaces';

const ContractForm = ({
  onFinishHandler,
  onClose,
}: {
  onFinishHandler: (data: IWorkingConditionContract) => void;
  onClose: () => void;
}) => {
  const { t, i18n } = useTranslation();

  return (
    <Form layout="vertical" onFinish={values => onFinishHandler(values)}>
      <Form.Item
        name={'contractType'}
        label={t('employee:workingConditions.labels.contractType.title')}
        rules={[
          {
            required: true,
            message: t('employee:workingConditions.validation.contractTypeRequired'),
          },
        ]}
      >
        <SelectInput placeholder={t('common:placeholders.selectFromList')}>
          {Object.keys(EmployeeContractTypesEnum).map(key => (
            <SelectInput.Option key={key} value={key}>
              {t(`employee:workingConditions.labels.contractType.${camelCase(key)}`)}
            </SelectInput.Option>
          ))}
        </SelectInput>
      </Form.Item>
      <Form.Item
        name={'hireDate'}
        label={t('common:labels.hireDate')}
        rules={[
          {
            required: true,
            message: t('common:validation.error.fieldRequired'),
          },
        ]}
      >
        <DatePickerInput inputReadOnly={true} lang={i18n.language} format="DD.MM.YYYY" />
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const contractType = getFieldValue('contractType');
          return contractType === EmployeeContractTypesEnum.FIXED ? (
            <Form.Item
              name={'endDate'}
              label={t('employee:workingConditions.labels.endDate')}
              rules={[
                {
                  required: true,
                  message: t('common:validation.error.fieldRequired'),
                },
              ]}
            >
              <DatePickerInput inputReadOnly={true} lang={i18n.language} format="DD.MM.YYYY" />
            </Form.Item>
          ) : null;
        }}
      </Form.Item>

      <ButtonsWrapper marginTop={16}>
        <Button type="primary" htmlType="submit">
          {t('common:buttons.save')}
        </Button>
        <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default ContractForm;
